import { DWArrayTableOcr } from 'src/components/array-table-ocr';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWArrayTableOcr.displayName, DWArrayTableOcr);
export default DWArrayTableOcr;
export { DWArrayTableOcr };
